import React, { useState } from "react";
import {
  Grid,
  Container,
  Card,
  CardHeader,
  CardContent,
  Button,
  Box,
} from "@mui/material";
import DOMPurify from "dompurify";
import { useNavigate } from "react-router-dom";
import Header, { HeaderType } from "../../components/Header";
import SelectInput from "../../components/SelectInput";

const renderQuillHtml = (html?: string) => ({
  __html: DOMPurify.sanitize(html ?? ""),
});

const WhatsMyCover: React.FC<any> = (_props) => {
  const [description, setDescription] = useState<string>();
  const [showOption, setShowOption] = useState<boolean>();
  const navigate = useNavigate();

  const UpdateDescription = (description: string) => {
    setDescription(description);
    setShowOption(true);
  };

  const cancelMyCover = () => navigate(-1);

  return (
    <div>
      <Header type={HeaderType.WhatsMyCover} />
      <Container maxWidth="sm">
        <Grid container spacing={1}>
          <Grid size={12}>
            <Card variant="outlined" style={{ padding: "15px" }}>
              <Grid
                container
                direction="row"
                justifyContent="center"
                spacing={1}
              >
                <Grid size={12}>
                  <SelectInput
                    loading={false}
                    updateDescription={UpdateDescription}
                  />
                  <br />
                </Grid>
              </Grid>

              {showOption === true && (
                <Grid size={12}>
                  <Grid container justifyContent="center">
                    <CardHeader
                      title="Product Info"
                      style={{
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                      }}
                    />
                  </Grid>
                  <hr />

                  <CardContent
                    style={{
                      paddingLeft: 0,
                      paddingRight: 0,
                      paddingTop: 0,
                      wordWrap: "break-word",
                    }}
                  >
                    <Box
                      sx={{
                        "& p": { margin: "0 0 8px 0" },
                        "& ol, & ul": {
                          paddingLeft: "20px",
                          margin: "0 0 8px 0",
                        },
                        "& li": { marginBottom: "4px" },
                        "& a": { color: "primary.main" },
                      }}
                      dangerouslySetInnerHTML={renderQuillHtml(description)}
                    />
                  </CardContent>
                </Grid>
              )}

              <Grid size={12}>
                <br />
                <Button
                  onClick={cancelMyCover}
                  value="cancel"
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  size="large"
                >
                  <strong>Cancel</strong>
                </Button>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default WhatsMyCover;
